.bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background: var(--bg-dark);
  color: var(--text-on-dark);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px calc(14px + env(safe-area-inset-bottom, 0px));
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.2);
}

.info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.count {
  font-size: 13px;
  color: var(--text-on-dark-faint);
}

.price {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 26px;
  font-variant-numeric: tabular-nums;
}

.continue {
  flex-shrink: 0;
  height: 52px;
  padding: 0 24px;
  border-radius: var(--r-12);
  background: var(--accent-strong);
  color: #fff;
  font-weight: 700;
  font-size: 19px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
}
/* Same fix as RegistrationCard.module.css's .signupBtn:hover - global.css's `a:hover` would
   otherwise override this <a>'s text color on hover instead of just darkening the button. */
.continue:hover {
  filter: brightness(0.92);
  color: #fff;
}
